export var VacationRentalsAvailabilityRequestEnum;
(function (VacationRentalsAvailabilityRequestEnum) {
    VacationRentalsAvailabilityRequestEnum["FollowupSearch"] = "FollowupSearch";
    VacationRentalsAvailabilityRequestEnum["InitialSearch"] = "InitialSearch";
})(VacationRentalsAvailabilityRequestEnum || (VacationRentalsAvailabilityRequestEnum = {}));
export var AvailabilityModeEnum;
(function (AvailabilityModeEnum) {
    AvailabilityModeEnum["Unspecified"] = "Unspecified";
    AvailabilityModeEnum["AVAILABLE_ONLY"] = "AVAILABLE_ONLY";
    AvailabilityModeEnum["UNAVAILABLE_ONLY"] = "UNAVAILABLE_ONLY";
    AvailabilityModeEnum["AVAILABLE_FIRST"] = "AVAILABLE_FIRST";
})(AvailabilityModeEnum || (AvailabilityModeEnum = {}));
export var SelectionEnum;
(function (SelectionEnum) {
    SelectionEnum["PlaceId"] = "PlaceId";
    SelectionEnum["Empty"] = "Empty";
    SelectionEnum["CityName"] = "CityName";
    SelectionEnum["ListingIds"] = "ListingIds";
})(SelectionEnum || (SelectionEnum = {}));
export var ValidCityEnum;
(function (ValidCityEnum) {
    ValidCityEnum["PalmSpringsCalifornia"] = "PalmSpringsCalifornia";
    ValidCityEnum["BocaRatonFlorida"] = "BocaRatonFlorida";
    ValidCityEnum["ThirtyAFlorida"] = "ThirtyAFlorida";
    ValidCityEnum["GonzalesTexas"] = "GonzalesTexas";
    ValidCityEnum["NashvilleTennessee"] = "NashvilleTennessee";
    ValidCityEnum["OahuHawaii"] = "OahuHawaii";
    ValidCityEnum["SantaBarbaraCalifornia"] = "SantaBarbaraCalifornia";
    ValidCityEnum["LakeHavasuArizona"] = "LakeHavasuArizona";
    ValidCityEnum["NewportBeachCalifornia"] = "NewportBeachCalifornia";
    ValidCityEnum["BreckenridgeColorado"] = "BreckenridgeColorado";
    ValidCityEnum["ParkCityUtah"] = "ParkCityUtah";
    ValidCityEnum["CentralOregonOregon"] = "CentralOregonOregon";
    ValidCityEnum["SanDiegoCalifornia"] = "SanDiegoCalifornia";
    ValidCityEnum["ScottsdaleArizona"] = "ScottsdaleArizona";
    ValidCityEnum["CoachellaValleyCalifornia"] = "CoachellaValleyCalifornia";
    ValidCityEnum["MonterreyBayCalifornia"] = "MonterreyBayCalifornia";
    ValidCityEnum["MalibuCalifornia"] = "MalibuCaliforni";
    ValidCityEnum["TellurideColorado"] = "TellurideColorado";
    ValidCityEnum["KeyWestFlorida"] = "KeyWestFlorida";
    ValidCityEnum["AngelFireNewMexico"] = "AngelFireNewMexico";
    ValidCityEnum["TemeculaCalifornia"] = "TemeculaCalifornia";
    ValidCityEnum["MauiHawaii"] = "MauiHawaii";
    ValidCityEnum["NaplesFlorida"] = "NaplesFlorida";
    ValidCityEnum["OregonCoastOregon"] = "OregonCoastOregon";
    ValidCityEnum["LosAngelesCalifornia"] = "LosAngelesCalifornia";
    ValidCityEnum["BrokenBowOklahoma"] = "BrokenBowOklahoma";
    ValidCityEnum["BrianHeadUtah"] = "BrianHeadUtah";
    ValidCityEnum["AnnaMariaIslandFlorida"] = "AnnaMariaIslandFlorida";
    ValidCityEnum["KohalaCoastHawaii"] = "KohalaCoastHawaii";
    ValidCityEnum["PasoRoblesCalifornia"] = "PasoRoblesCalifornia";
    ValidCityEnum["SiestaKeyFlorida"] = "SiestaKeyFlorida";
    ValidCityEnum["LakeArrowheadCalifornia"] = "LakeArrowheadCalifornia";
    ValidCityEnum["BarbadosIntl"] = "BarbadosIntl";
    ValidCityEnum["MiramarFlorida"] = "MiramarFlorida";
    ValidCityEnum["DestinFlorida"] = "DestinFlorida";
    ValidCityEnum["SedonaArizona"] = "SedonaArizona";
    ValidCityEnum["BerkshiresMassachusetts"] = "BerkshiresMassachusetts";
    ValidCityEnum["JoshuaTreeCalifornia"] = "JoshuaTreeCalifornia";
    ValidCityEnum["VailColorado"] = "VailColorado";
    ValidCityEnum["FortLauderdaleFlorida"] = "FortLauderdaleFlorida";
    ValidCityEnum["CharlestonSouthCarolina"] = "CharlestonSouthCarolina";
    ValidCityEnum["SonomaCalifornia"] = "SonomaCalifornia";
    ValidCityEnum["BigBearCalifornia"] = "BigBearCalifornia";
    ValidCityEnum["LakeTahoeCalifornia"] = "LakeTahoeCalifornia";
    ValidCityEnum["FredericksburgTexas"] = "FredericksburgTexas";
    ValidCityEnum["CaboSanLucasIntl"] = "CaboSanLucasIntl";
    ValidCityEnum["AustinTexas"] = "AustinTexas";
    ValidCityEnum["AshevilleNorthCarolina"] = "AshevilleNorthCarolina";
    ValidCityEnum["SmokyMountainsTennessee"] = "SmokyMountainsTennessee";
    ValidCityEnum["BreackenridgeColorado"] = "BreackenridgeColorado";
    ValidCityEnum["HiltonHeadSouthCarolina"] = "HiltonHeadSouthCarolina";
    ValidCityEnum["HudsonValleyNewYork"] = "HudsonValleyNewYork";
    ValidCityEnum["NorthLakeTahoeCalifornia"] = "NorthLakeTahoeCalifornia";
})(ValidCityEnum || (ValidCityEnum = {}));
export var AvailabilityResultEnum;
(function (AvailabilityResultEnum) {
    AvailabilityResultEnum["Available"] = "Available";
    AvailabilityResultEnum["Empty"] = "Empty";
    AvailabilityResultEnum["Error"] = "Error";
    AvailabilityResultEnum["Unavailable"] = "Unavailable";
})(AvailabilityResultEnum || (AvailabilityResultEnum = {}));
export var UnavailableReasonEnum;
(function (UnavailableReasonEnum) {
    UnavailableReasonEnum["MinStayViolation"] = "MinStayViolation";
    UnavailableReasonEnum["MaxStayViolation"] = "MaxStayViolation";
    UnavailableReasonEnum["OccupancyViolation"] = "OccupancyViolation";
    UnavailableReasonEnum["PetPolicyViolation"] = "PetPolicyViolation";
    UnavailableReasonEnum["CheckInNotAllowed"] = "CheckInNotAllowed";
    UnavailableReasonEnum["CheckOutNotAllowed"] = "CheckOutNotAllowed";
    UnavailableReasonEnum["BlockedDates"] = "BlockedDates";
    UnavailableReasonEnum["MinBookingWindowViolation"] = "MinBookingWindowViolation";
})(UnavailableReasonEnum || (UnavailableReasonEnum = {}));
export var FeeKindEnum;
(function (FeeKindEnum) {
    FeeKindEnum["TravelerServiceFee"] = "TravelerServiceFee";
    FeeKindEnum["Unspecified"] = "Unspecified";
    FeeKindEnum["CleaningFee"] = "CleaningFee";
    FeeKindEnum["HopperServiceFee"] = "HopperServiceFee";
    FeeKindEnum["PropertyFee"] = "PropertyFee";
    FeeKindEnum["HotelFees"] = "HotelFees";
    FeeKindEnum["PetFee"] = "PetFee";
    FeeKindEnum["ResortFees"] = "ResortFees";
})(FeeKindEnum || (FeeKindEnum = {}));
export var TaxKindEnum;
(function (TaxKindEnum) {
    TaxKindEnum["OccupancyFee"] = "OccupancyFee";
    TaxKindEnum["SalesTax"] = "SalesTax";
    TaxKindEnum["Unspecified"] = "Unspecified";
    TaxKindEnum["TaxRecoveryCharges"] = "TaxRecoveryCharges";
    TaxKindEnum["Unknown"] = "Unknown";
    TaxKindEnum["CityTaxes"] = "CityTaxes";
})(TaxKindEnum || (TaxKindEnum = {}));
export var DiscountKindEnum;
(function (DiscountKindEnum) {
    DiscountKindEnum["LongStay"] = "LongStay";
    DiscountKindEnum["LastMinute"] = "LastMinute";
    DiscountKindEnum["FirstBookings"] = "FirstBookings";
    DiscountKindEnum["Monthly"] = "Monthly";
    DiscountKindEnum["Unspecified"] = "Unspecified";
    DiscountKindEnum["Weekly"] = "Weekly";
    DiscountKindEnum["EarlyBird"] = "EarlyBird";
    DiscountKindEnum["BasicCalendar"] = "BasicCalendar";
})(DiscountKindEnum || (DiscountKindEnum = {}));
export var FundingEnum;
(function (FundingEnum) {
    FundingEnum["Empty"] = "Empty";
    FundingEnum["JointFunded"] = "JointFunded";
    FundingEnum["HostFunded"] = "HostFunded";
    FundingEnum["HopperFunded"] = "HopperFunded";
})(FundingEnum || (FundingEnum = {}));
export var PolicyEnum;
(function (PolicyEnum) {
    PolicyEnum["FullyRefundable"] = "FullyRefundable";
    PolicyEnum["NonRefundable"] = "NonRefundable";
    PolicyEnum["PartiallyRefundable"] = "PartiallyRefundable";
    PolicyEnum["Unknown"] = "Unknown";
})(PolicyEnum || (PolicyEnum = {}));
export var PaymentPolicyScheduleEnum;
(function (PaymentPolicyScheduleEnum) {
    PaymentPolicyScheduleEnum["FullPaymentDueNow"] = "FullPaymentDueNow";
    PaymentPolicyScheduleEnum["PaymentText"] = "PaymentText";
    PaymentPolicyScheduleEnum["UnspecifiedPaymentSchedule"] = "UnspecifiedPaymentSchedule";
})(PaymentPolicyScheduleEnum || (PaymentPolicyScheduleEnum = {}));
export var EffectiveRangeEnum;
(function (EffectiveRangeEnum) {
    EffectiveRangeEnum["Available"] = "Available";
    EffectiveRangeEnum["NotAvailable"] = "NotAvailable";
})(EffectiveRangeEnum || (EffectiveRangeEnum = {}));
export var MerchantOfRecordKindEnum;
(function (MerchantOfRecordKindEnum) {
    MerchantOfRecordKindEnum["Unspecified"] = "Unspecified";
    MerchantOfRecordKindEnum["Hopper"] = "Hopper";
    MerchantOfRecordKindEnum["Provider"] = "Provider";
})(MerchantOfRecordKindEnum || (MerchantOfRecordKindEnum = {}));
export var ListingCollectionEnum;
(function (ListingCollectionEnum) {
    ListingCollectionEnum["Premier"] = "Premier";
    ListingCollectionEnum["Lifestyle"] = "Lifestyle";
    ListingCollectionEnum["NoCollection"] = "NoCollection";
})(ListingCollectionEnum || (ListingCollectionEnum = {}));
export var AmenityKindEnum;
(function (AmenityKindEnum) {
    AmenityKindEnum["Accessibility"] = "Accessibility";
    AmenityKindEnum["AccessibleBathroom"] = "AccessibleBathroom";
    AmenityKindEnum["AccessibleFacilities"] = "AccessibleFacilities";
    AmenityKindEnum["AirConditioning"] = "AirConditioning";
    AmenityKindEnum["AllergyFriendly"] = "AllergyFriendly";
    AmenityKindEnum["BarbecueGrill"] = "BarbecueGrill";
    AmenityKindEnum["BarInBuilding"] = "BarInBuilding";
    AmenityKindEnum["Bathtub"] = "Bathtub";
    AmenityKindEnum["BeachFront"] = "BeachFront";
    AmenityKindEnum["BeachView"] = "BeachView";
    AmenityKindEnum["BedLinens"] = "Bed Linens";
    AmenityKindEnum["Bicycle"] = "Bicycle";
    AmenityKindEnum["BoardGames"] = "BoardGames";
    AmenityKindEnum["Cable"] = "Cable";
    AmenityKindEnum["CarbonMonoxideAlarm"] = "CarbonMonoxideAlarm";
    AmenityKindEnum["CeilingFan"] = "CeilingFan";
    AmenityKindEnum["CityView"] = "CityView";
    AmenityKindEnum["CleaningProducts"] = "CleaningProducts";
    AmenityKindEnum["Coffee"] = "Coffee";
    AmenityKindEnum["CoffeeMaker"] = "CoffeeMaker";
    AmenityKindEnum["CoffeeTea"] = "CoffeeTea";
    AmenityKindEnum["ConvenientCheckInOut"] = "ConvenientCheckInOut";
    AmenityKindEnum["CookingBasics"] = "CookingBasics";
    AmenityKindEnum["Crib"] = "Crib";
    AmenityKindEnum["DedicatedWorkspace"] = "DedicatedWorkspace";
    AmenityKindEnum["DiningTable"] = "DiningTable";
    AmenityKindEnum["DishesAndSilverware"] = "DishesAndSilverware";
    AmenityKindEnum["Dishwasher"] = "Dishwasher";
    AmenityKindEnum["DoormanEntry"] = "DoormanEntry";
    AmenityKindEnum["Dryer"] = "Dryer";
    AmenityKindEnum["Elevator"] = "Elevator";
    AmenityKindEnum["Entertainment"] = "Entertainment";
    AmenityKindEnum["Essentials"] = "Essentials";
    AmenityKindEnum["EvCharger"] = "EvCharger";
    AmenityKindEnum["ExtraPillowsAndBlankets"] = "ExtraPillowsAndBlankets";
    AmenityKindEnum["FireExtinguisher"] = "FireExtinguisher";
    AmenityKindEnum["FirePit"] = "FirePit";
    AmenityKindEnum["Fireplace"] = "Fireplace";
    AmenityKindEnum["FirstAidKit"] = "FirstAidKit";
    AmenityKindEnum["FitnessCenter"] = "FitnessCenter";
    AmenityKindEnum["FreeParking"] = "FreeParking";
    AmenityKindEnum["Freezer"] = "Freezer";
    AmenityKindEnum["FrontDesk"] = "FrontDesk";
    AmenityKindEnum["GamingConsole"] = "GamingConsole";
    AmenityKindEnum["GardenOrBackyard"] = "GardenOrBackyard";
    AmenityKindEnum["Gym"] = "Gym";
    AmenityKindEnum["HairDryer"] = "HairDryer";
    AmenityKindEnum["Hangers"] = "Hangers";
    AmenityKindEnum["Hdtv"] = "Hdtv";
    AmenityKindEnum["Heating"] = "Heating";
    AmenityKindEnum["HighChair"] = "HighChair";
    AmenityKindEnum["HotTub"] = "HotTub";
    AmenityKindEnum["HotWater"] = "HotWater";
    AmenityKindEnum["HotWaterKettle"] = "HotWaterKettle";
    AmenityKindEnum["Housekeeping"] = "Housekeeping";
    AmenityKindEnum["InternetAccess"] = "InternetAccess";
    AmenityKindEnum["Iron"] = "Iron";
    AmenityKindEnum["Kayak"] = "Kayak";
    AmenityKindEnum["KidFriendly"] = "KidFriendly";
    AmenityKindEnum["Kitchen"] = "Kitchen";
    AmenityKindEnum["Kitchenette"] = "Kitchenette";
    AmenityKindEnum["Laundry"] = "Laundry";
    AmenityKindEnum["MealAvailable"] = "MealAvailable";
    AmenityKindEnum["Microwave"] = "Microwave";
    AmenityKindEnum["MountainView"] = "MountainView";
    AmenityKindEnum["NatureView"] = "NatureView";
    AmenityKindEnum["OnDemandHousekeeping"] = "OnDemandHousekeeping";
    AmenityKindEnum["OutdoorSeating"] = "OutdoorSeating";
    AmenityKindEnum["OutdoorSpace"] = "OutdoorSpace";
    AmenityKindEnum["Oven"] = "Oven";
    AmenityKindEnum["PaidParking"] = "PaidParking";
    AmenityKindEnum["Parking"] = "Parking";
    AmenityKindEnum["PatioOrBalcony"] = "PatioOrBalcony";
    AmenityKindEnum["PetFriendly"] = "PetFriendly";
    AmenityKindEnum["Piano"] = "Piano";
    AmenityKindEnum["PingPongTable"] = "PingPongTable";
    AmenityKindEnum["Pool"] = "Pool";
    AmenityKindEnum["PoolTable"] = "PoolTable";
    AmenityKindEnum["PrivateEntrance"] = "PrivateEntrance";
    AmenityKindEnum["PropertyView"] = " PropertyView";
    AmenityKindEnum["Refrigerator"] = "Refrigerator";
    AmenityKindEnum["RestaurauntInBuilding"] = "RestaurauntInBuilding";
    AmenityKindEnum["Sauna"] = "Sauna";
    AmenityKindEnum["SecureEntry"] = "SecureEntry";
    AmenityKindEnum["SecureStorage"] = "SecureStorage";
    AmenityKindEnum["SecuritySystem"] = "SecuritySystem";
    AmenityKindEnum["Shampoo"] = "Shampoo";
    AmenityKindEnum["SkiInSkiOut"] = "SkiInSkiOut";
    AmenityKindEnum["SmokeAlarm"] = "SmokeAlarm";
    AmenityKindEnum["SmokingAllowed"] = "SmokingAllowed";
    AmenityKindEnum["SoundSystem"] = "SoundSystem";
    AmenityKindEnum["Stove"] = "Stove";
    AmenityKindEnum["StreetParking"] = "StreetParking";
    AmenityKindEnum["Toaster"] = "Toaster";
    AmenityKindEnum["Unspecified"] = "Unspecified";
    AmenityKindEnum["WardrobeOrCloset"] = "WardrobeOrCloset";
    AmenityKindEnum["Washer"] = "Washer";
    AmenityKindEnum["Waterfront"] = "Waterfront";
    AmenityKindEnum["WaterView"] = "WaterView";
    AmenityKindEnum["Wifi"] = "Wifi";
})(AmenityKindEnum || (AmenityKindEnum = {}));
export var ListingAddressEnum;
(function (ListingAddressEnum) {
    ListingAddressEnum["FullAddress"] = "FullAddress";
    ListingAddressEnum["ObfuscatedAddress"] = "ObfuscatedAddress";
    ListingAddressEnum["Empty"] = "Empty";
})(ListingAddressEnum || (ListingAddressEnum = {}));
export var ProviderCategoryEnum;
(function (ProviderCategoryEnum) {
    ProviderCategoryEnum["Unspecified"] = "Unspecified";
    ProviderCategoryEnum["OTA"] = "OTA";
    ProviderCategoryEnum["B2B"] = "B2B";
    ProviderCategoryEnum["Hopper"] = "Hopper";
})(ProviderCategoryEnum || (ProviderCategoryEnum = {}));
export var SpecificityEnum;
(function (SpecificityEnum) {
    SpecificityEnum["Approximate"] = "Approximate";
    SpecificityEnum["Exact"] = "Exact";
})(SpecificityEnum || (SpecificityEnum = {}));
// TODO - VR: Use what's necessary + dedup from existing models, BE is deduping models so these will change
// export interface HomesPriceQuoteRateCancellationPolicy {
//   policy: HomesPriceQuoteRateCancellationPolicyPolicy;
//   isRefundable?: boolean;
// }
// /**
//  * @type HomesPriceQuoteRateCancellationPolicyPolicy
//  * @export
//  */
// export type HomesPriceQuoteRateCancellationPolicyPolicy =
//   | ({ Policy: "CancellationSchedule" } & CancellationSchedule)
//   | ({ Policy: "Empty" } & Empty)
//   | ({ Policy: "NonRefundable" } & NonRefundable)
//   | ({ Policy: "RefundableInfo" } & RefundableInfo);
// export interface HomesPriceQuoteRateCancellationPolicyPolicyOneOf {
//   Policy: Policy;
// }
// export const Policy = {
//   CancellationSchedule: "CancellationSchedule",
//   Empty: "Empty",
//   NonRefundable: "NonRefundable",
//   RefundableInfo: "RefundableInfo",
// } as const;
// export type Policy = (typeof Policy)[keyof typeof Policy];
// export interface HomesPriceQuoteRateCancellationPolicyPolicyOneOf1 {
//   info: string;
//   Policy: Policy;
// }
// export const Policy = {
//   CancellationSchedule: "CancellationSchedule",
//   Empty: "Empty",
//   NonRefundable: "NonRefundable",
//   RefundableInfo: "RefundableInfo",
// } as const;
// export type Policy = (typeof Policy)[keyof typeof Policy];
// export interface HomesPriceQuoteRateCancellationPolicyPolicyOneOf2 {
//   steps: Array<HomesPriceQuoteRateCancellationPolicyPolicyOneOf2StepsInner>;
//   Policy: Policy;
// }
// export const Policy = {
//   CancellationSchedule: "CancellationSchedule",
//   Empty: "Empty",
//   NonRefundable: "NonRefundable",
//   RefundableInfo: "RefundableInfo",
// } as const;
// export type Policy = (typeof Policy)[keyof typeof Policy];
// export interface HomesPriceQuoteRateCancellationPolicyPolicyOneOf2StepsInner {
//   penalty: HomesPriceQuoteRateCancellationPolicyPolicyOneOf2StepsInnerPenalty;
//   start?: string;
//   end?: string;
// }
// export interface HomesPriceQuoteRateCancellationPolicyPolicyOneOf2StepsInnerPenalty {
//   penalty: HomesPriceQuoteRateCancellationPolicyPolicyOneOf2StepsInnerPenaltyPenalty;
// }
// /**
//  * @type HomesPriceQuoteRateCancellationPolicyPolicyOneOf2StepsInnerPenaltyPenalty
//  * @export
//  */
// export type HomesPriceQuoteRateCancellationPolicyPolicyOneOf2StepsInnerPenaltyPenalty =
//     | ({ Penalty: "Empty" } & Empty)
//     | ({ Penalty: "FlatFee" } & FlatFee)
//     | ({ Penalty: "NumberOfNights" } & NumberOfNights)
//     | ({ Penalty: "PercentageTotal" } & PercentageTotal);
// export interface HomesPriceQuoteRateCancellationPolicyPolicyOneOf2StepsInnerPenaltyPenaltyOneOf {
//   Penalty: Penalty;
// }
// export const Penalty = {
//   Empty: "Empty",
//   FlatFee: "FlatFee",
//   NumberOfNights: "NumberOfNights",
//   PercentageTotal: "PercentageTotal",
// } as const;
// export type Penalty = (typeof Penalty)[keyof typeof Penalty];
// export interface HomesPriceQuoteRateCancellationPolicyPolicyOneOf2StepsInnerPenaltyPenaltyOneOf1 {
//   fee: number;
//   Penalty: Penalty;
// }
// export const Penalty = {
//   Empty: "Empty",
//   FlatFee: "FlatFee",
//   NumberOfNights: "NumberOfNights",
//   PercentageTotal: "PercentageTotal",
// } as const;
// export type Penalty = (typeof Penalty)[keyof typeof Penalty];
// export interface HomesPriceQuoteRateCancellationPolicyPolicyOneOf2StepsInnerPenaltyPenaltyOneOf2 {
//   nights: number;
//   Penalty: Penalty;
// }
// export const Penalty = {
//   Empty: "Empty",
//   FlatFee: "FlatFee",
//   NumberOfNights: "NumberOfNights",
//   PercentageTotal: "PercentageTotal",
// } as const;
// export type Penalty = (typeof Penalty)[keyof typeof Penalty];
// export interface HomesPriceQuoteRateCancellationPolicyPolicyOneOf2StepsInnerPenaltyPenaltyOneOf3 {
//   percentage: number;
//   Penalty: Penalty;
// }
// export const Penalty = {
//   Empty: "Empty",
//   FlatFee: "FlatFee",
//   NumberOfNights: "NumberOfNights",
//   PercentageTotal: "PercentageTotal",
// } as const;
// export type Penalty = (typeof Penalty)[keyof typeof Penalty];
export var GroupedHomesLineItemEnum;
(function (GroupedHomesLineItemEnum) {
    GroupedHomesLineItemEnum["VacationRental"] = "VacationRental";
    GroupedHomesLineItemEnum["Taxes"] = "Taxes";
    GroupedHomesLineItemEnum["CleaningFees"] = "CleaningFees";
    GroupedHomesLineItemEnum["HostAndManagementFees"] = "HostAndManagementFees";
})(GroupedHomesLineItemEnum || (GroupedHomesLineItemEnum = {}));
export var HomesPriceQuoteRateDetailedPriceFeesInnerKindEnum;
(function (HomesPriceQuoteRateDetailedPriceFeesInnerKindEnum) {
    HomesPriceQuoteRateDetailedPriceFeesInnerKindEnum["CityTax"] = "CityTax";
    HomesPriceQuoteRateDetailedPriceFeesInnerKindEnum["CleaningFee"] = "CleaningFee";
    HomesPriceQuoteRateDetailedPriceFeesInnerKindEnum["Fee"] = "Fee";
    HomesPriceQuoteRateDetailedPriceFeesInnerKindEnum["HopperServiceFee"] = "HopperServiceFee";
    HomesPriceQuoteRateDetailedPriceFeesInnerKindEnum["HotelFee"] = "HotelFee";
    HomesPriceQuoteRateDetailedPriceFeesInnerKindEnum["OccupancyFee"] = "OccupancyFee";
    HomesPriceQuoteRateDetailedPriceFeesInnerKindEnum["PetFee"] = "PetFee";
    HomesPriceQuoteRateDetailedPriceFeesInnerKindEnum["PropertyFee"] = "PropertyFee";
    HomesPriceQuoteRateDetailedPriceFeesInnerKindEnum["RecoveryChargesTax"] = "RecoveryChargesTax";
    HomesPriceQuoteRateDetailedPriceFeesInnerKindEnum["ResortFee"] = "ResortFee";
    HomesPriceQuoteRateDetailedPriceFeesInnerKindEnum["SalesTax"] = "SalesTax";
    HomesPriceQuoteRateDetailedPriceFeesInnerKindEnum["Tax"] = "Tax";
    HomesPriceQuoteRateDetailedPriceFeesInnerKindEnum["TravelerServiceFee"] = "TravelerServiceFee";
})(HomesPriceQuoteRateDetailedPriceFeesInnerKindEnum || (HomesPriceQuoteRateDetailedPriceFeesInnerKindEnum = {}));
export var ReservationSettlementInfoEnum;
(function (ReservationSettlementInfoEnum) {
    ReservationSettlementInfoEnum["Direct"] = "Direct";
    ReservationSettlementInfoEnum["InterpolatedUserCard"] = "InterpolatedUserCard";
    ReservationSettlementInfoEnum["Vcc"] = "Vcc";
})(ReservationSettlementInfoEnum || (ReservationSettlementInfoEnum = {}));
export var InstigatorEnum;
(function (InstigatorEnum) {
    InstigatorEnum["Guest"] = "Guest";
    InstigatorEnum["Host"] = "Host";
})(InstigatorEnum || (InstigatorEnum = {}));
var UserPaymentEnum;
(function (UserPaymentEnum) {
    UserPaymentEnum["CarrotCashCredit"] = "CarrotCashCredit";
    UserPaymentEnum["CreditCard"] = "CreditCard";
    UserPaymentEnum["InterpolatedUserCard"] = "InterpolatedUserCard";
    UserPaymentEnum["Other"] = "Other";
})(UserPaymentEnum || (UserPaymentEnum = {}));
export var HomesReservationStatus;
(function (HomesReservationStatus) {
    HomesReservationStatus["Cancelled"] = "Cancelled";
    HomesReservationStatus["Confirmed"] = "Confirmed";
    HomesReservationStatus["Unknown"] = "Unknown";
})(HomesReservationStatus || (HomesReservationStatus = {}));
export var AddMainGuestResponseEnum;
(function (AddMainGuestResponseEnum) {
    AddMainGuestResponseEnum["Failure"] = "Failure";
    AddMainGuestResponseEnum["Success"] = "Success";
})(AddMainGuestResponseEnum || (AddMainGuestResponseEnum = {}));
export var HomeBookErrorType;
(function (HomeBookErrorType) {
    HomeBookErrorType["InvalidQuote"] = "Invalid Quote";
    HomeBookErrorType["NotAvailable"] = "NotAvailable";
    HomeBookErrorType["RateNotAvailable"] = "RateNotAvailable";
    HomeBookErrorType["CreditCardDeclined"] = "CreditCardDeclined";
    HomeBookErrorType["InsufficientFunds"] = "InsufficientFunds";
    HomeBookErrorType["CreditCardExpired"] = "CreditCardExpired";
    HomeBookErrorType["CreditCardLostStolen"] = "CreditCardLostStolen";
    HomeBookErrorType["CreditCardNotSupported"] = "CreditCardNotSupported";
    HomeBookErrorType["InvalidCreditCardNumber"] = "InvalidCreditCardNumber";
    HomeBookErrorType["InvalidCreditCardInformation"] = "InvalidCreditCardInformation";
    HomeBookErrorType["InvalidCreditCardVerificationNumber"] = "InvalidCreditCardVerificationNumber";
    HomeBookErrorType["Fraud"] = "Fraud";
    HomeBookErrorType["InvalidGuestCountry"] = "InvalidGuestCountry";
    HomeBookErrorType["Experiment"] = "Experiment";
    HomeBookErrorType["InvalidFulfillmentInput"] = "InvalidFulfillmentInput";
    HomeBookErrorType["InvalidCreditCardCountryCode"] = "InvalidCreditCardCountryCode";
    HomeBookErrorType["InvalidCreditCardZipCode"] = "InvalidCreditCardZipCode";
})(HomeBookErrorType || (HomeBookErrorType = {}));
//# sourceMappingURL=vacation-rentals.js.map